/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

import axios from 'axios'
import Auth from '@helpers/Auth'
import { Stub, StubUrl } from '../Stub'

const URL = StubUrl('User')

const Obj = {
  ...Stub(URL()),
  updateAvatar (url = !1) {
    const a = URL('update-avatar')
    return url === !0 ? a : axios.post(a)
  },
  destroyAvatar (url = !1) {
    const a = URL('destroy-avatar')
    return url === !0 ? a : axios.delete(a)
  },
  sideMenu: () => axios.get('get-side-menu'),
  profile: () => axios.get(URL('profile')),
  refreshProfile () {
    return this.profile().then((response) => {
      const { data } = response || {}
      if (data && data.data && data.success === true) {
        Auth.save({ user: data.data })
      }
      return response
    })
  },
  updateAccount: form => axios.post(URL('update-account'), form),
  updateProfile: form => axios.post(URL('update-profile'), form),
  updatePassword: ({ password, password_confirmation }) => axios.post(URL('update-password'), { password, password_confirmation }),
  updateLocale: locale => axios.post(URL('update-locale'), { locale }),
  updateSignature: signature => axios.post(URL('update-signature'), { signature }),
  destroySignature: (id) => axios.delete(URL(`${id}/DestroySignature`)),
  activeUser: id => axios.get(URL(`${id}/Active`)),
  inactiveUser: id => axios.get(URL(`${id}/Inactive`)),
  dashboard: params => axios.get(URL('Dashboard'), { params })
}

export default Obj
